import { Component, Input } from '@angular/core';
import { TemplateType } from 'app/main/pages/templates/template.dto';

@Component({
  selector: 'app-template-icon',
  templateUrl: './template-icon.component.html',
  styleUrl: './template-icon.component.scss'
})
export class TemplateIconComponent {

  @Input() type: TemplateType;
  @Input() cssVariant: string = '';
  public templateType = TemplateType;
}
